import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';
import { AppSettings } from "../../proyect.conf";
import { ListSolicitudesPagare, SolicitudPagare } from '../_models/solicitud-pagare';
import { AutenticacionService } from "./autenticacion.service";

@Injectable({
  providedIn: "root",
})
export class SolicitudesPagaresService {
  private rutServicio =
    AppSettings.rutServiciosAPL + "/api/solicitudesUCPagares/";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listado() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(
        map((res) => res as SolicitudPagare[])
      );
  }

  listadoHabilitados() {
    return this.httpClient
      .get(this.rutServicio + 'enabled')
      .pipe(
        map((res) => res as SolicitudPagare[])
      );
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(
        map((res) => res as SolicitudPagare)
      );
  }

  obtenerPorIdSolicitud(idSolicitudUC: string) {
    return this.httpClient
      .get(this.rutServicio + "solicitudUC/" + idSolicitudUC + "/enabled")
      .pipe(
        map((res) => res as SolicitudPagare)
      );
  }

  obtenerPorIdSolicitudNumeroPagare(idSolicitudUC: string, numeroPagareDeceval: number){
    return this.httpClient
      .get(this.rutServicio + "unique/solicitudUC/" + idSolicitudUC + "/decevalNo/"+ numeroPagareDeceval )
      .pipe(
        map((res) => res as SolicitudPagare)
      );
  }

  validarExisteFirmaPagare(idSolicitudUC: string) {
    return this.httpClient
      .get(this.rutServicio + 'validarPagareFirmado/solicitudUC/' + idSolicitudUC + '/enabled' )
      .pipe(
        map((res) => res as any)
      );
  }

  agregar(regCrear: SolicitudPagare) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(
        map((res) => res as SolicitudPagare)
      );
  }

  actualizar(regActualizar: SolicitudPagare) {
    regActualizar.auditoriaUsuario =
      this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(
        map((res) => res as SolicitudPagare)
      );
  }

  contador(){
    return this.httpClient.get(this.rutServicio + 'count/solicitudesUCPendienteAnularPagare').pipe(map((res) => res as number));
  }

  listaAnuladoPagare(data:any){
    return this.httpClient.post(this.rutServicio + 'solicitudesUCPendienteAnularPagare', data).pipe(map((res) => res as ListSolicitudesPagare));
  }

  anuladoPorIdUsuario() {
    return this.httpClient.get(this.rutServicio + 'solicitudesUCPendienteAnularPagare/usuario/' + this.autServicio.obtenerIdUsuarioLogueado()).pipe(map((res) => res as any));
  }

  anuladoPorIdSolicitudUC(idSolicitudUC: string) {
    return this.httpClient.get(this.rutServicio + 'solicitudesUCPendienteAnularPagare/suc/' + idSolicitudUC + '/usuario/' + this.autServicio.obtenerIdUsuarioLogueado()).pipe(map((res) => res as any));
  }

}
